import DENTToothMobility from './DENTToothMobility';
import DENTToothFurcation from './DENTToothFurcation';
import React from 'react';
import { ToothView } from '../../Enums/ToothView.enum';
import { Tooth } from '../../../../graphql/graphql';

interface Props {
	tooth?: Tooth;
	width: number;
	height: number;
	view: ToothView;
}

const DENTToothIcons = (props: Props) => {
	return (
		<>
			<DENTToothMobility {...props} />
			<DENTToothFurcation {...props} />
		</>
	);
};

export default DENTToothIcons;
